import React from 'react'
import { Form, Input } from 'antd'
import css from './Form.css'

const FormInput = ({ label, name, value, onChange }) => (
  <Form.Item
    label={label}
    className={css.input}
  >
    <Input
      value={value}
      name={name}
      onChange={onChange}
    />
  </Form.Item>
)

export default FormInput



// WEBPACK FOOTER //
// ./src/common/Input.js